<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>Simulation Overview</mat-panel-title>
  </mat-expansion-panel-header>

  <div>
    <div class="simulation-details">
      <span class="detail-label">Simulation name:</span>
      <span class="detail-value">{{simulationResponse?.name || ''}}</span>
    </div>
    <div class="simulation-details">
      <span class="detail-label">Rock file name:</span>
      <span class="detail-value rock-file-link" (click)="openRockFilePreview()">
        {{getFileNameWithoutExtension(simulationResponse?.fileName)}}
      </span>
    </div>
    @if (hasRockModel) {
      <div class="simulation-details">
        <span class="detail-label">Rock model name:</span>
        <span class="detail-value rock-file-link" (click)="openRockModelPreview()">
          {{rockModelName}}
        </span>
      </div>
    }
    @if (hasFluidFlowModel) {
      <div class="simulation-details">
        <span class="detail-label">Fluid flow model name:</span>
        <span class="detail-value rock-file-link" (click)="openFluidFlowModelPreview()">{{fluidFlowModelName}}</span>
      </div>
    }
  </div>
</mat-expansion-panel>
